import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ProfilePage = () => {
    const navigate = useNavigate();
    const [switchTab, setSwitchTab] = useState(1);
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});

    const validate = () => {
        const errors = {};
        if (!currentPassword) errors.currentPassword = "Current password is required.";
        if (switchTab === 1) {
            if (!newPassword) errors.newPassword = "New password is required.";
            if (!confirmPassword) errors.confirmPassword = "Please confirm your new password.";
            if (newPassword !== confirmPassword)
                errors.confirmPassword = "Passwords do not match.";
        }
        return errors;
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) return;

        try {
            const token = localStorage.getItem("token");
            const endpoint = switchTab === 1
                ? process.env.REACT_APP_CHANGE_PASSWORD
                : process.env.REACT_APP_DEACTIVE_ACCOUNT;

            const payload = switchTab === 1
                ? { currentPassword, newPassword, confirmPassword }
                : { currentPassword };

            const res = await axios.post(endpoint, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setMessage(res.data.message || (switchTab === 1 ? "Password updated successfully." : "Account deleted successfully."));
            setTimeout(()=>{
                setMessage(null)
            },3000)
            setError(null);
            setFieldErrors({});
            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");

            if (switchTab === 2) {
                localStorage.clear();
                navigate("/login");
            }
        } catch (err) {
            setError(err.response?.data?.message || err.message || "An error occurred.");
            setMessage(null);
        }
    };


    const deactiveAccount = async (e) => {
        e.preventDefault();
        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) return;

        try {
            alert(process.env.REACT_APP_DEACTIVE_ACCOUNT)
            const token = localStorage.getItem("token");
            const endpoint = switchTab === 1
                ? process.env.REACT_APP_CHANGE_PASSWORD
                : process.env.REACT_APP_DEACTIVE_ACCOUNT;

            const payload = switchTab === 1
                ? { currentPassword, newPassword, confirmPassword }
                : { currentPassword };

            const res = await axios.post(endpoint, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setMessage(res.data.message || (switchTab === 1 ? "Password updated successfully." : "Account deactive successfully."));
            setTimeout(()=>{
                setMessage(null)
            },3000)
            setError(null);
            setFieldErrors({});
            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");

            if (switchTab === 2) {
                localStorage.clear();
                navigate("/login");
            }
        } catch (err) {
            setError(err.response?.data?.message || err.message || "An error occurred.");
            setMessage(null);
        }
    };

    const renderTabContent = () => {
        switch (switchTab) {
            case 1:
                return (
                    <form onSubmit={handleSubmit}>
                        <InputField
                            label="Current Password"
                            value={currentPassword}
                            onChange={setCurrentPassword}
                            error={fieldErrors.currentPassword}
                        />
                        <InputField
                            label="New Password"
                            value={newPassword}
                            onChange={setNewPassword}
                            error={fieldErrors.newPassword}
                        />
                        <InputField
                            label="Confirm New Password"
                            value={confirmPassword}
                            onChange={setConfirmPassword}
                            error={fieldErrors.confirmPassword}
                        />
                        <SubmitButton text="Update Password" />
                    </form>
                );
            case 2:
                return (
                    <form onSubmit={handleSubmit}>
                        <InputField
                            label="Current Password"
                            value={currentPassword}
                            onChange={setCurrentPassword}
                            error={fieldErrors.currentPassword}
                        />
                        <SubmitButton text="Delete Account" />
                    </form>
                );
            default:
                return null;
        }
    };

    return (
        <main className="min-h-screen bg-gray-50 px-4 py-10 sm:px-6 lg:px-8">
            <div className="max-w-3xsl mx-auto">
                <header className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                    <div>
                        <h2 className="text-3xl font-bold text-gray-900">Profile Settings</h2>
                        <p className="text-sm text-gray-500">Manage your password and account settings</p>
                    </div>
                    <button
                        className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg text-sm hover:bg-gray-300"
                        onClick={() => navigate(-1)}
                    >
                        ← Back
                    </button>
                </header>

                <div className="bg-white rounded-lg shadow-md p-6">
                    {/* Tabs */}
                    <nav className="flex space-x-6 border-b border-gray-200 mb-6">
                        {["Change Password", "Delete Account"].map((label, index) => (
                            <button
                                key={label}
                                onClick={() => setSwitchTab(index + 1)}
                                className={`pb-2 text-sm font-medium border-b-2 ${
                                    switchTab === index + 1
                                        ? "border-blue-600 text-blue-600"
                                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                                }`}
                            >
                                {label}
                            </button>
                        ))}
                    </nav>

                    {/* Form + Alerts */}
                    {message && <p className="text-green-600 text-sm mb-4">{message}</p>}
                    {error && <p className="text-red-600 text-sm mb-4">{error}</p>}

                    {renderTabContent()}
                </div>
            </div>
        </main>
    );
};

const InputField = ({ label, value, onChange, error }) => (
    <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
        <input
            type="password"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
        {error && <p className="text-red-600 text-sm mt-1">{error}</p>}
    </div>
);

const SubmitButton = ({ text }) => (
    <button
        type="submit"
        className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition"
    >
        {text}
    </button>
);

export default ProfilePage;
